import { Card } from "../Card"
import { useState, useEffect, useRef } from "react";

import { createDeck2,createDeck, shuffleDeck } from "../../utils/card_helper";
import "./index.scss"


export const Board = () => {
    const [boardArray, setBoardArray] = useState([]);
    const [selectedSet,setSelectedSet] = useState(new Set());
    const [numberMatches,setNumberMatches] = useState(0);

    let deck = useRef();
    

    useEffect(() => {
        deck.current = createDeck();
        console.log("Starting deck length: " + deck.length);
        setBoardArray(createBoard());

    },[])

  

    const createBoard = () => {
        let board = []
        for(let i = 0; i < 9; i++){
            board.push(deck.current.pop());
        }

    

        console.log("Deck size: " + deck.current.length);
        return board;
    }

    const dealCard = () => {
        if(boardArray.length < 9){
            boardArray.push(deck.current.pop());
            setBoardArray([...boardArray]);
        }

      console.log("Size of deck after dealing card: " + deck.current.length);
    }

    const hasOnlyJQK = () => {
        let indices = selectedSet.values();

        
        for(let selectedIndex of indices){
            if(!([11,12,13].includes(boardArray[selectedIndex].rank))){
                return false;
            }
        }

        return true;
    }

    const removeSelected = () => {
        let indices = [...selectedSet.values()];

        for(let i = 0; i < indices.length; i++){
            let indexSelected = indices[i];
            console.log("indexSelected is: " + indexSelected);
            console.log("card for indexSelected is: " + boardArray[indexSelected])
            deck.current.push({
                rank: boardArray[indexSelected].rank,
                suit: boardArray[indexSelected].suit,
            })
           
            console.log("Size of Deck after returning removed item: " + deck.current.length);
           
        };
        
        

        let newBoard = boardArray.filter((_,index) => {
            return !selectedSet.has(index);
        })

        setBoardArray(newBoard);

        selectedSet.clear();
        setSelectedSet(new Set());
        console.log("Deck Size after removing card: " + deck.current.length);
    }

    const removeMatched = () => {
       
        let filteredBoard = boardArray.filter((_,index) => {
            return selectedSet.has(index);
        })

        let combinedRank = filteredBoard.reduce((prev,current) => { return prev + current.rank }, 0)
        
        if(combinedRank === 11 || hasOnlyJQK()){
            let newBoard = boardArray.filter((_,index) => {
                return !selectedSet.has(index);
            })
             setNumberMatches(numberMatches+1);
            setBoardArray(newBoard);
            setSelectedSet(new Set());
        }
    }

    return (<div className="main-container">
        <div className="title-container">
            <h1>Elevens Game</h1>
            <h2>Number of Matches: {numberMatches}</h2>
        </div>
        <div className="board-container">
            { boardArray.map((card,index) => {
                
                return <Card 
                    isSelected={selectedSet.has(index)} 
                    toggleSelection={  () => {
                        console.log(selectedSet);
                        if(selectedSet.has(index)){
                            selectedSet.delete(index);
                            setSelectedSet(new Set(selectedSet));
                        }else {

                            if(selectedSet.size === 2 && hasOnlyJQK()){
                                if([11,12,13].includes(boardArray[index].rank)){
                                    selectedSet.add(index);
                                    setSelectedSet(new Set(selectedSet));
                                }
                                
                            }else if(selectedSet.size < 2){
                                selectedSet.add(index);
                                setSelectedSet(new Set(selectedSet));
                            }
                            
                        }

                    }
                    
                    } 
                    rank={card.rank} 
                    suit={card.suit} 
                    key={card.suit + card.rank}></Card>
            })}
        </div>
        <div className="button-container">
            <button onClick={dealCard}>Deal Card</button>
            <button onClick={removeSelected}>Remove Selected</button>
            <button onClick={removeMatched}>Remove Matched</button>
        </div>
    </div>)
}